// «vtl» вместо «вед»: поиск, переживающий забытую раскладку клавиатуры.
//
// Ctrl+K нажимают не глядя, и в этот момент раскладка та, в которой человек работал секунду
// назад. У финансового директора это регулярно английская: имена файлов, адреса, выгрузки
// в Excel. Он печатает «dtl», видит пустую палитру и делает единственный разумный вывод —
// «не работает» — после чего возвращается к мыши и больше не пробует.
//
// Поэтому запрос, по которому ничего не нашлось, пробуется второй раз, переложенный на
// русскую раскладку. Второй попыткой, а не первой: слово, которое нашлось как есть, важнее
// того, что могло бы найтись после перекладки.

/** Английская клавиша → русская буква на том же месте (ЙЦУКЕН). */
const КЛАВИШИ: Readonly<Record<string, string>> = {
  q: 'й', w: 'ц', e: 'у', r: 'к', t: 'е', y: 'н', u: 'г', i: 'ш', o: 'щ', p: 'з',
  '[': 'х', ']': 'ъ',
  a: 'ф', s: 'ы', d: 'в', f: 'а', g: 'п', h: 'р', j: 'о', k: 'л', l: 'д',
  ';': 'ж', "'": 'э',
  z: 'я', x: 'ч', c: 'с', v: 'м', b: 'и', n: 'т', m: 'ь',
  ',': 'б', '.': 'ю',
};

/**
 * Переложить строку с английской раскладки на русскую.
 *
 * Возвращает исходную строку без изменений, если перекладывать нечего: тогда вызывающий
 * не делает второго прохода поиска впустую.
 */
export function сРаскладки(строка: string): string {
  let вышло = '';
  let менялось = false;
  for (const знак of строка.toLowerCase()) {
    const русский = КЛАВИШИ[знак];
    if (русский === undefined) {
      вышло += знак;
      continue;
    }
    вышло += русский;
    менялось = true;
  }
  return менялось ? вышло : строка;
}
